import styled from 'styled-components'
import { BP } from 'resources/constants'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import bgShapes from 'app/sofia/scenes/ProductSelector/images/bg4.jpg'

export const Container = styled.div`
  ${sectionCss}
  min-height: 50vh;
  background: ${props => props.theme.palette.primary.alpha};
  position: relative;
  max-width: none;
  background-size: ${BP.lg.max};
  background-repeat: no-repeat;
  background-position: center bottom;
  background-image: url(${bgShapes});

  > div {
    width: 80%;
    max-width: 500px;
    margin: 20px auto;
    padding: 40px;
    background: ${props => props.theme.palette.general.light};
    border-radius: 10px;
    text-align: center !important;
    box-sizing: border-box;

    h2 {
      ${props => props.theme.css.heading1};
    }

    > p {
      ${props => props.theme.css.heading2};
    }

    button {
      margin: 20px auto 0;
    }
  }
`
